import React from "react";
import PropTypes from "prop-types";

import goToLinkInternally from "../../common/helpers/goToLinkInternally";

export const RenderUrl = ({ url, label }) => (
  <a
    style={{ wordWrap: "break-word" }}
    href={url}
    onClick={(e) => goToLinkInternally(url, e)}
  >
    {label}
  </a>
);

RenderUrl.propTypes = {
  url: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
};
